<template>
  <base-material-card
    id="coloured-line"
    color="warning"
    icon="mdi-chart-timeline-variant"
    class="px-4 py-3"
  >
    <template #after-heading>
      <div class="display-1 font-weight-light mt-2">
        vOffice Regestrierungen
      </div>
    </template>

    <chartist
      :data="chartData"
      :options="chartOptions"
      type="Line"
      style="max-height: 150px;"
      class="mt-3"
    />
    <div class="legende d-flex align-center">
      <span class="leg">Legende: </span>
      <span class="all">Alle</span>
      <span class="vof">vOffice</span>
      <span class="ram">RA-MICRO</span>
    </div>
  </base-material-card>
</template>

<script>
  import monthRangeFromBegin from '@/utils/monthRangeFromBegin'

  export default {
    data () {
      return {
        chartData: {
          labels: monthRangeFromBegin(),
          series: [[], [], []],
        },
        chartOptions: {
          low: 0,
          high: 800, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
      }
    },
    mounted () {
      this.loadChart()
    },
    methods: {
      loadChart () {
        const beginDate = new Date('2020-03-01')
        const endDate = new Date('2020-04-01')

        while (beginDate < Date.now()) {
          const allDomainCount = Object.values(this.$store.getters.allDomains.stats)
            .filter(item => (item.createdAt > Date.parse(beginDate) && item.createdAt < Date.parse(endDate))).length

          const allRamDomainCount = Object.entries(this.$store.getters.allDomains.stats)
            .filter(item => (item[1].createdAt > Date.parse(beginDate) && item[1].createdAt < Date.parse(endDate) && item[0].split('.')[1] === 'ra-micro')).length

          this.chartData.series[0].push(allDomainCount)
          this.chartData.series[1].push(allRamDomainCount)
          this.chartData.series[2].push(allDomainCount - allRamDomainCount)

          beginDate.setMonth(beginDate.getMonth() + 1)
          endDate.setMonth(endDate.getMonth() + 1)
        }
      },
      complete (index) {
        this.list[index] = !this.list[index]
      },
    },
  }
</script>

<style lang="sass">
  #coloured-line
    .ct-series-a .ct-line,
    .ct-series-a .ct-point
      stroke: #4caf50 !important

    .ct-series-b .ct-line,
    .ct-series-b .ct-point
      stroke: #cc0000 !important

    .ct-series-c .ct-line,
    .ct-series-c .ct-point
      stroke: #00cae3 !important

  .legende
   font-size: 12px
   color: #999999
   margin-top: 1rem
  .legende
    &>:not(:last-child)
      margin-right: 1rem
  .vof
   &::before
     content: ''
     display: inline-block
     width: 12px
     height: 12px
     background-color: #00cae3
     margin-right: 5px
     border-radius: 2px
  .ram
    &::before
     content: ''
     display: inline-block
     width: 12px
     height: 12px
     background-color: #cc0000
     margin-right: 5px
     border-radius: 2px
  .all
    &::before
     content: ''
     display: inline-block
     width: 12px
     height: 12px
     background-color: #4caf50
     margin-right: 5px
     border-radius: 2px
</style>
